import { I18n } from '@calendly/i18n';
import { Banner } from '@calendly/ui/components/banner';
import { AlertWarningTriangleIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { forwardRef } from 'react';
const billingPageWrapperCss = "b11tsshf";
const BillingPageWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(billingPageWrapperCss, props.className)} />;
});
export const SubscriptionPaymentPendingBanner = () => {
  const title = I18n.t('publisher.billing.subscription_payment_pending.banner.title');
  const body = I18n.t('publisher.billing.subscription_payment_pending.banner.body');
  return <Banner icon={AlertWarningTriangleIcon} title={title} type="warning">
      <p>
        {body}
      </p>
    </Banner>;
};
export const PaymentPendingStage = () => <BillingPageWrapper data-testid="billing-page-wrapper">
    <SubscriptionPaymentPendingBanner />
  </BillingPageWrapper>;

require("./payment_pending_stage.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./payment_pending_stage.js");